import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './UtilitiesComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function UtilitiesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UtilitiesComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const isAuxiliaryHeatNotNone = () => !_.isUndefined(_.get(modelVM, 'auxHeaFie.value.code'))
        && _.get(modelVM, 'auxHeaFie.value.code') !== 'None'

    const isAuxHeatFuelTypeWood = () => (!_.isUndefined(_.get(modelVM, 'auxHeaFie.value.code'))
        && _.get(modelVM, 'auxHeaFie.value.code') === 'ComwitWoo')
        || (!_.isUndefined(_.get(modelVM, 'auxHeaFueTypFie.value.code'))
            && _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Wood')        
        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthExpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'priHeaFie.value.code')) && _.get(modelVM, 'priHeaFie.value.code') === 'Other'
        },
        ifOthExp2Fie: {
            visible: !_.isUndefined(_.get(modelVM, 'priHeaFueTypFie.value.code')) && _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Oth'
        },
        auxHeaFueTypFie: {
            visible: isAuxiliaryHeatNotNone()
        },
        ifOthExp3Fie: {
            visible: isAuxiliaryHeatNotNone()
                && !_.isUndefined(_.get(modelVM, 'auxHeaFueTypFie.value.code')) && _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Oth'
        },
        yeaofIns2Fie: {
            visible: isAuxiliaryHeatNotNone()
        },
        yealasupd2Fie: {
            visible: isAuxiliaryHeatNotNone()
        },
        ifAppAnnCorofWooBuBurFie: {
            visible: isAuxHeatFuelTypeWood(),
            defaultValue: 0
        },
        ifAppAnnBagofPelBuBurFie: {
            visible: isAuxHeatFuelTypeWood(),
            defaultValue: 0
        },
        typoffusFie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'fusFie')) && _.get(modelVM.value, 'fusFie')
        },
        perofhomthaisKnoanTubFie1: {
            visible: !_.isUndefined(_.get(modelVM.value, 'knoTubWirFie')) && _.get(modelVM.value, 'knoTubWirFie')
        },
        istheknoandtubwirlkitFie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'knoTubWirFie')) && _.get(modelVM.value, 'knoTubWirFie')
        },
        perofAluWirinHomFie1: {
            visible: !_.isUndefined(_.get(modelVM.value, 'aluWirFie')) && _.get(modelVM.value, 'aluWirFie')
        },
        ifOthindnumofampFie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'howmanampistheelessysFie'))
                && _.get(modelVM.value, 'howmanampistheelessysFie') === 'Other'
        },
        ifOthExp4Fie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'typofPluFie'))
                && _.get(modelVM.value, 'typofPluFie') === 'Oth'
        }
        // ifAppAnnCorofWooBuBurFie: {
        //     visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComwitWoo'
        // },
        // ifAppAnnBagofPelBuBurFie: {
        //     visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComwitWoo'
        // },
        // ifOthindnumofampFie: {
        //     visible: _.get(modelVM, 'howmanampistheelessysFie.value.code') === 'Other'
        // }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UtilitiesComponent.propTypes = wizardProps;
export default withRouter(UtilitiesComponent);